<template>
  <DbsLinkButton label="利用規約" url="https://www.emot.jp/termsb.html" />
</template>

<script>
export default {
  name: "DbsTermsLinkButton",
};
</script>
